import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class PopupModalService {
    async getPopupData(id) {
        const response = await axios.get(Config.apiBasePath + '/getPopupModal/' + id, {headers: authHeader()});
        return response;
    }

    async deletePopup(id) {
        const response = await axios.get(Config.apiBasePath + '/deletePopupModal/' + id, {headers: authHeader()});
        return response;
    }

    async savePopupData(data) {
        const response = await axios.post(Config.apiBasePath + '/savePopupModal', data, {headers: authHeader()});
        return response;
    }

    async updatePopupData(data) {
        const response = await axios.post(Config.apiBasePath + '/updatePopupModal', data, {headers: authHeader()});
        return response;
    }

    async getAllPopupModalData() {
        const response = await axios.get(Config.apiBasePath + '/getAllPopupModal', {headers: authHeader()});
        return response;
    }
}

export default new PopupModalService();
